module.exports = __webpack_public_path__ + "img/fraction1-2.b4326723.svg";